import React, { ReactNode } from "react";

import { LoadingSpinner } from "../loaders/LoadingSpinner";
import styles from "./Link.module.scss";

export interface Props {
  id?: string;
  children: ReactNode;
  loading?: boolean;
  leading?: ReactNode;
  href?: string;
  onClick: () => void | Promise<void>;
}

export const Link = ({ id, children, loading, leading, onClick, href }: Props) => (
  <a id={id} href={href} className={`${styles.link} ${loading ? styles.link_loading : ""}`} onClick={onClick}>
    <span className={leading || loading ? styles.leading : ""}>
      {loading && <LoadingSpinner />}
      {!loading && leading}
    </span>
    {children}
  </a>
);
